<template v-model="panel">
  <div
    v-if="childCourse"
    class="detail"
  >
    <div
      v-for="(course, index) in childCourse"
      :key="index"
      :id="course.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()">
      <h4
        :style="myTitleStyle"
        class="title-name">
        {{ courseName(course) }}
        <span
          v-if="completeFill(course)"
          :style="noteStyle1"
        ><br>({{ pleaseSelectMsg(course) }})
        </span>
        <span
          v-else-if="course.req_len && course.course_items.length > 0"
          :style="noteStyle2"
        ><br>({{ pleaseSelectMsg(course) }})
        </span>
      </h4>
      <div
        v-for="(courseitem, index) in course.course_items"
        :key="index">
          <v-layout
            row
            align-center
            class="option"
          >
          <v-flex xs8 sm10
                  v-if="parseInt(rid) === 941
                  && (parseFloat(courseitem.price_override) > 0 && courseitem.price && courseitem.price > courseitem.price_override)">
            <v-radio-group
              v-if="course.selector === 'radio'"
              v-model="course.selected"
              @change="changeCourseItems(courseitem, course)"
            >
              <v-radio
                :value="courseitem.item_id"
                :color="theme.checked_color"
                :dark="dark"
                :disabled="!itemAvailable(courseitem)"
              >
                <template slot="label">
                  <span :style="mySubTitleStyle2(courseitem)">{{ courseName(courseitem) }}</span> <span style="color: grey" v-if="!itemAvailable(courseitem)">(Sold out)</span>
                </template>
              </v-radio>
            </v-radio-group>
            <v-checkbox
              v-else
              v-model="course.selected"
              :value="courseitem.item_id"
              :color="theme.checked_color"
              @change="changeCourseItems(courseitem, course)"
              :dark="dark"
              :multiple="course.multiple"
              :disabled="!itemAvailable(courseitem)"
            >
              <template slot="label">
                <span :style="mySubTitleStyle2(courseitem)">{{ courseName(courseitem) }}</span> <span style="color: grey" v-if="!itemAvailable(courseitem)">(Sold out)</span>
              </template>
            </v-checkbox>
          </v-flex>
          <v-flex xs10 v-else>
          <v-radio-group
            v-if="course.selector === 'radio'"
            v-model="course.selected"
            @change="changeCourseItems(courseitem, course)"
          >
            <v-radio
              :value="courseitem.item_id"
              :color="theme.checked_color"
              :dark="dark"
              :disabled="!itemAvailable(courseitem)"
            >
              <template slot="label">
                <span :style="mySubTitleStyle2(courseitem)">{{ courseName(courseitem) }}</span> <span style="color: grey" v-if="!itemAvailable(courseitem)">(Sold out)</span>
              </template>
            </v-radio>
          </v-radio-group>
          <v-checkbox
            v-else
            v-model="course.selected"
            :value="courseitem.item_id"
            :color="theme.checked_color"
            @change="changeCourseItems(courseitem, course)"
            :dark="dark"
            :multiple="course.multiple"
            :disabled="!itemAvailable(courseitem)"
          >
            <template slot="label">
              <span :style="mySubTitleStyle2(courseitem)">{{ courseName(courseitem) }}</span> <span style="color: grey" v-if="!itemAvailable(courseitem)">(Sold out)</span>
            </template>
          </v-checkbox>
        </v-flex>

        <v-flex
          xs4 sm2
          text-xs-right
          :style="myPriceStyle"
          v-if="parseInt(rid) === 941
                && (parseFloat(courseitem.price_override) > 0 && courseitem.price && courseitem.price > courseitem.price_override)"
        >
          <span v-if="parseFloat(courseitem.price_override) > 0" style="font-size: smaller"><del v-if="courseitem.price && courseitem.price > courseitem.price_override">(+{{ $n(courseitem.price, 'currency') }})</del>(+{{ $n(courseitem.price_override, 'currency') }})</span>
        </v-flex>
        <v-flex
          xs2
          text-xs-right
          :style="myPriceStyle"
          v-else
        >
          <span v-if="parseFloat(courseitem.price_override) > 0">(+{{ $n(courseitem.price_override, 'currency') }})</span>
        </v-flex>

        </v-layout>
        <v-layout
          row
          align-center
        >
          <v-flex xs12>
            <course-item-component
              v-if="courseitem.has_courses && checkSelectedItems(course.selected, courseitem.item_id)"
              :course="courseitem"
            />
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'course-item-component',
  data () {
    return {
      childCourse: null,
      panel: null
    }
  },
  props: {
    course: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe', 'language', 'rid', 'mode'
    ]),
    ...mapGetters('cart', [
      'itemQtyInCart', 'pickupDate'
    ]),
    myTitleStyle () {
      return {
        color: this.theme.dialog_content_name2_color
      }
    },
    mySubTitleStyle () {
      return {
        fontSize: '14px',
        color: this.theme.dialog_content_name2_color
      }
    },
    myPriceStyle () {
      return {
        fontSize: '14px',
        color: this.theme.dialog_content_price_color,
        marginBottom: '2px'
      }
    },
    dark () {
      return parseInt(this.theme.menu_theme) === 1
    },
    noteStyle1 () {
      return {
        fontWeight: 400,
        fontSize: 'smaller',
        color: this.theme.text_disabled_color
      }
    },
    noteStyle2 () {
      return {
        fontWeight: 400,
        fontSize: 'smaller',
        color: this.theme.text_enabled_color
      }
      // return {
      //   fontWeight: 400,
      //   fontSize: 'smaller',
      //   color: 'white',
      //   textShadow: `-1px 0 ${this.theme.text_enabled_color}, 0 1px ${this.theme.text_enabled_color},
      //     1px 0 ${this.theme.text_enabled_color}, 0 -1px ${this.theme.text_enabled_color}`
      // }
    }
  },
  methods: {
    completeFill (course) {
      if (course.req_len === 1 && course.course_items.length === 1) {
        course.selected = course.course_items[0].item_id
      }
      return (course.req_len && this.checkRequired(course.req_len, course.max_len, course.selected))
        || (!course.req_len && course.max_len && course.course_items.length > course.max_len)
    },
    pleaseSelectMsg (course) {
      if (course.req_len && course.max_len && (course.req_len !== course.max_len)) {
        return this.$t('pls_select_1') + this.$t(course.req_len) + this.$t('to') + this.$t(course.max_len) + this.$t('pls_select_2')
      } else if (course.req_len) {
        return this.$t('pls_select_1') + this.$t(course.req_len) + this.$t('pls_select_2')
      } else if (course.max_len) {
        return this.$t('select_up_to') + this.$t(course.max_len) + this.$t('pls_select_2')
      }
    },
    checkRequired (reqLen, maxLen, selected) {
      if (!reqLen) {
        return true
      }
      if (reqLen === 1) {
        return Array.isArray(selected) ? selected.length >= reqLen : !!(selected)
      }
      return !!(selected && (!maxLen ? selected.length === reqLen : selected.length >= reqLen && selected.length <= maxLen))
    },
    changeCourseItems (courseitem, course) {
      if ((Array.isArray(course.selected) ? course.selected.length : 1) > course.max_len) {
        if (Array.isArray(course.selected)) {
          const i = course.selected.findIndex(i => i === courseitem.item_id)
          if (i !== -1) {
            course.selected.pop()
          }
        } else {
          course.selected = null
        }
      }
      if (courseitem.has_courses !== 1) {
        this.$store.dispatch('menu/processMenuItem', 'course')
      }
    },
    checkSelectedItems (selected, item_id) {
      if (Array.isArray(selected)) {
        return selected.includes(item_id)
      }
      return selected == item_id
    },
    courseName (course) {
      if (this.language !== 'en-SG') {
        return course.alternate_name || course.name
      }
      return course.name
    },
    itemAvailable(i) {
      // const d2 = moment(this.pickupDate)
      // const today = moment()
      // if (!this.mode.isDinein && !(d2.isSame(today, 'day'))) return true
      return parseInt(i.is_enabled) === 1 && (i.inventory_left.toUpperCase() === 'NA'
        || parseInt(i.inventory_left) > 0)
    },
    mySubTitleStyle2 (i) {
      return {
        color: this.theme.dialog_content_name2_color,
        textDecoration: this.itemAvailable(i) ? '' : 'line-through'
      }
    },
  },
  watch: {
    async panel (val) {
      if (val !== null) {
        if (!this.course.courses) {
          await this.$store.dispatch('menu/fetchCourseItem', this.course)
        }
        this.childCourse = this.course.courses
      }
    }
  },
  mounted () {
    this.panel = 0
  },
  beforeDestroy () {
    if (this.course.courses) {
      this.$store.dispatch('menu/processMenuItem', 'course')
    }
  }
}
</script>

<style scoped>
.note {
  font-weight: 400;
  font-size: smaller;
}
.title-name {
  margin-top: -15px;
  margin-bottom: 24px;
}
.option {
  margin-top: -32px;
}
.detail {
  padding-left: 22px;
  margin-top: -8px;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/CourseDetail.vue